import { render } from "./trainInfo.vue?vue&type=template&id=c9b8a068&scoped=true"
import script from "./trainInfo.vue?vue&type=script&lang=js"
export * from "./trainInfo.vue?vue&type=script&lang=js"

import "./trainInfo.vue?vue&type=style&index=0&id=c9b8a068&lang=scss&scoped=true"

import exportComponent from "D:\\jll-web-xintan\\xinfu-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9b8a068"]])

export default __exports__